import { styled } from '@mui/material/styles';
import { Image, Stack } from 'core/common/ui/ui-kit';

export const ContentStyled = styled(Stack)`
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 0 12px;
`;

export const WingImageStyled = styled(Image)`
  transform: ${({ theme }) => (theme.direction === 'rtl' ? 'scaleX(-1)' : 'none')};
`;

export const WingImageReversedStyled = styled(Image)`
  transform: ${({ theme }) => (theme.direction === 'rtl' ? 'none' : 'scaleX(-1)')};
`;
